<style>
  .dropdown-menu.pullDown {
    width: 520px !important;
    background: #FFF8E5;
  }

  .dropdown-menu.pullDown .notific-txt {
    color: #766326;
    font-size: 19px;
  }

  .notifications-wrapper .img-circul {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    background-color: #d5b969;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  .notifications-wrapper .img-circul i {
    height: auto !important;
    font-size: 30px;
    color: #766326;
  }

  .notifications-wrapper .noti-hd-txt {
    color: #766326;
    font-size: 20px;
  }

  .notifications-wrapper .noti-rows {
    padding: 10px;
    background: #FFFFFF;
    box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px;
    border-radius: 10px;
    line-height: normal !important;
  }

  .notifications-wrapper .side-content {
    flex: 1 0 auto;
  }

  .notifications-wrapper .hd-txt {
    color: #766326;
    font-weight: 500;
    font-size: 18px;
    width: 300px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .notifications-wrapper .sub-txt {
    color: #766326;
    font-size: 16px;
  }

  .sub-txt.full-txt {
    width: 399px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .tab-content-nt {
    height: 441px;
    overflow-y: auto;
  }

  .notifications-wrapper .tab-heading p {
    line-height: 2;
  }

  .user_profile .dropdown-menu.pf-drop-down {
    width: 195px !important;
  }
</style>

<nav #navbar class="cust-nav navbar active">
  <div class="container-fluid">
    <div class="navbar-header">
      <a onClick="javacript:void(0)" class="navbar-toggle collapsed" data-toggle="collapse"
        data-target="#navbar-collapse" aria-expanded="false"></a>
      <a onClick="javacript:void(0)" class="bars" (click)="mobileMenuSidebarOpen($event, 'overlay-open')"></a>
      <span class="navbar-brand" (click)="goDashbord()">
        <img  src="assets/images/salonza/sidebar-logo.png" alt="" />
        <span class="logo-name"></span>
      </span>
    </div>

    <div class="collapse navbar-collapse" id="navbar-collapse">
      <ul class="pull-left collapse-menu-icon d-flex align-item-center">
        <li style="display:inline-block">
          <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse">
            <!-- <mat-icon>menu</mat-icon> -->
            <svg xmlns="http://www.w3.org/2000/svg" width="35px" height="35px" viewBox="0 0 16 16" fill="none">

              <g fill="#766326">
              
              <path d="M11.726 5.263a.7.7 0 10-.952-1.026l-3.5 3.25a.7.7 0 000 1.026l3.5 3.25a.7.7 0 00.952-1.026L8.78 8l2.947-2.737z"/>
              
              <path fill-rule="evenodd" d="M1 3.25A2.25 2.25 0 013.25 1h9.5A2.25 2.25 0 0115 3.25v9.5A2.25 2.25 0 0112.75 15h-9.5A2.25 2.25 0 011 12.75v-9.5zm2.25-.75a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h1.3v-11h-1.3zm9.5 11h-6.8v-11h6.8a.75.75 0 01.75.75v9.5a.75.75 0 01-.75.75z" clip-rule="evenodd"/>
              
              </g>
              
              </svg>
          </button>
        </li>
        <li class="d-flex align-items-center ml-2" style="display:inline-block" *ngIf="loginPartner">
          <img *ngIf="loginPartner.image" src="{{ imgUrl + loginPartner.image.fileName }}" class="rounded-circle"
            width="40" height="40" alt="User" />
          <svg *ngIf="!router.url.includes('/admin')" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.90739 9.5H29.5926L32.8333 14.6042V19.7083H3.66666V14.6042L6.90739 9.5Z" stroke="#766326"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M15.3333 19.7083H29.9167V29.9167C29.9167 30.7221 29.2638 31.375 28.4583 31.375H16.7917C15.9862 31.375 15.3333 30.7221 15.3333 29.9167V19.7083Z"
              stroke="#766326" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6.58334 19.7083V31.375" stroke="#766326" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M28.4583 3.66666H8.04166" stroke="#766326" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>

          <label *ngIf="loginPartner.partnerName" for=""
            class="label partnerlabel mb-0">{{loginPartner.partnerName}}</label>
        </li>
      </ul>
      <!-- <ul class="nav navbar-nav navbar-right" *ngIf="!router.url.includes('/watchfuleye')">
        <li class="fullscreen">
          <button mat-icon-button (click)="callFullscreen()" class="nav-notification-icons">
            <mat-icon>fullscreen</mat-icon>
          </button>
        </li>
      </ul> -->
    </div>

    <!-- .nav-menu -->
    <div class="collapse navbar-collapse pr-nav" id="navbar-collapse" *ngIf="!router.url.includes('/watchfuleye')">
      <ul class="nav navbar-nav navbar-right" *ngIf="!router.url.includes('/watchfuleye')">
        <li *ngIf="userRole != '' || userRole != 'patient' &&  headerCall ">
          <iframe *ngIf="crmUrl != null || crmUrl != undefined" class="e2e-iframe-trusted-src" width="500" height="100"
            [src]="crmUrl"></iframe>
        </li>
        <li class="fullscreen" *ngIf="router.url.includes('/admin') || router.url.includes('/staff')">
          <button mat-icon-button (click)="$event.stopPropagation()" (click)="openCallDialog()"
            class="nav-notification-icons">
            <mat-icon>phone</mat-icon>
          </button>
        </li>
        <li class="fullscreen" *ngIf="router.url.includes('/admin') || router.url.includes('/staff')">
          <i (click)="closeCall()" class="dialer endcall" style="vertical-align: middle;"></i>
        </li>
        <li class="fullscreen" *ngIf="router.url.includes('/admin') || router.url.includes('/staff')">
          <button mat-icon-button (click)="$event.stopPropagation()" (click)="callHold()"
            class="nav-notification-icons">
            <mat-icon>pause</mat-icon>
          </button>
        </li>

        <li class="fullscreen" *ngIf="router.url.includes('/admin') || router.url.includes('/staff')">
          <button mat-icon-button (click)="$event.stopPropagation()" (click)="callHang()"
            class="nav-notification-icons">
            <mat-icon>phone_paused</mat-icon>
          </button>
        </li>

        <li class="fullscreen" *ngIf="router.url.includes('/admin') || router.url.includes('/staff')">
          <button mat-icon-button (click)="$event.stopPropagation()" (click)="callDial()"
            class="nav-notification-icons">
            <mat-icon>dialer_sip</mat-icon>
          </button>
        </li>
        <li class="fullscreen" *ngIf="router.url.includes('/admin') || router.url.includes('/staff')">
          <button mat-icon-button (click)="$event.stopPropagation()" (click)="callConference()"
            class="nav-notification-icons">
            <mat-icon>group_add</mat-icon>
          </button>
        </li>
        <li class="fullscreen" *ngIf="router.url.includes('/admin') || router.url.includes('/staff')">
          <button *ngIf="this.ambulanceData.length>0" mat-icon-button id="delete-product-button"
            (click)="$event.stopPropagation()" (click)="openAmbulanceModal(this.ambulanceData[0])"
            class="nav-notification-icons">
            <mat-icon>add_alert</mat-icon>
          </button>

        </li>
        <!-- multi select opction -->
        <li class="publish-txt" *ngIf="!router.url.includes('/admin')">
          <div class="dropdown">
            <button class="btn" type="button" data-toggle="dropdown" aria-expanded="false">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                id="Layer_1" x="0px" y="0px" width="30" height="30" viewBox="0 0 122.88 122.566"
                enable-background="new 0 0 122.88 122.566" xml:space="preserve" fill="#766326">
                <g>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M3.78,66.082h47.875c2.045,0,3.717,1.988,3.717,4.414v46.479 c0,2.43-1.671,4.416-3.717,4.416H3.78c-2.043,0-3.717-1.986-3.717-4.416V70.496C0.063,68.07,1.737,66.082,3.78,66.082L3.78,66.082z M71.224,0H119.1c2.046,0,3.717,1.986,3.717,4.415v46.479c0,2.429-1.671,4.413-3.717,4.413H71.224 c-2.045,0-3.714-1.984-3.714-4.413V4.415C67.51,1.986,69.179,0,71.224,0L71.224,0z M3.714,0h47.878 c2.045,0,3.717,1.986,3.717,4.415v46.479c0,2.429-1.671,4.413-3.717,4.413H3.714C1.671,55.307,0,53.323,0,50.894V4.415 C0,1.986,1.671,0,3.714,0L3.714,0z M71.287,67.26h47.876c2.043,0,3.717,1.986,3.717,4.416v46.479c0,2.426-1.674,4.412-3.717,4.412 H71.287c-2.045,0-3.717-1.986-3.717-4.412V71.676C67.57,69.246,69.242,67.26,71.287,67.26L71.287,67.26z" />
                </g>
              </svg>
            </button>
            <div class="dropdown-menu pr-short-cut-menu">
              <div class="d-flex align-items-center">
                <div class=" menu-items-pf pt-4 border-right">
                  <div class="Profile-datawrapper">
                    <h5 class="NameWrapper dirtyGreen tofino-b px-4">List View</h5>
                  </div>
                  <a class="dropdown-item pf-item" (click)="goToServiesPage()"> <img class="mr-3"
                      style="height: 20px; width: 25px;" src="../../../../assets/images/setting/service.png"> My Service
                  </a>
                  <a class="dropdown-item pf-item" (click)="goToVoucherPage()"><svg width="25" height="25"
                      viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-3">
                      <path
                        d="M23.4855 4.32837H23.4399C22.8735 4.32837 2.37896 4.32837 1.56006 4.32837C0.699854 4.32837 0 5.02822 0 5.88843V19.1115C0 19.9717 0.699854 20.6716 1.56006 20.6716C2.39917 20.6716 22.8947 20.6716 23.4399 20.6716H23.4855C24.3206 20.6716 25 19.9921 25 19.1571V19.1115V5.88843V5.84287C25 5.00781 24.3206 4.32837 23.4855 4.32837ZM14.8481 9.01846L15.4118 9.58213L14.8481 10.1458C14.3487 10.6453 14.3487 11.4579 14.8481 11.9575L15.4118 12.5211L14.8481 13.0848C14.3487 13.5842 14.3487 14.3969 14.8481 14.8964L15.4118 15.4601L14.8481 16.0239C14.3487 16.5233 14.3487 17.336 14.8481 17.8355L15.4118 18.3992C14.7945 19.0164 14.8247 18.9836 14.7706 19.0482H1.62339V5.95176H14.7369C14.8082 6.04492 14.7962 6.02754 15.4119 6.64316L14.8481 7.20688C14.3487 7.70635 14.3487 8.51909 14.8481 9.01846ZM23.3766 19.0483H17.0006C17.2889 18.5575 17.2226 17.9143 16.8019 17.4934L16.2382 16.9297L16.8019 16.3661C17.3013 15.8667 17.3013 15.054 16.8019 14.5544L16.2382 13.9908L16.8019 13.4271C17.3013 12.9277 17.3013 12.115 16.8019 11.6155L16.2382 11.0518L16.8019 10.4881C17.0438 10.2462 17.1771 9.92451 17.1771 9.58228C17.1771 9.24014 17.0438 8.91841 16.8019 8.67647L16.2382 8.11279L16.8019 7.54907C17.2349 7.11602 17.2924 6.44756 16.9746 5.9519H23.3766V19.0483V19.0483Z"
                        fill="#766326"></path>
                      <path
                        d="M10.0114 11.9164C9.08701 11.9164 8.38013 12.3079 8.38013 13.3845V14.9288C8.38013 16.0054 9.08701 16.3969 10.0114 16.3969C10.925 16.3969 11.6427 16.0054 11.6427 14.9288V13.3845C11.6427 12.3079 10.925 11.9164 10.0114 11.9164ZM10.0114 15.4508C9.67432 15.4508 9.47852 15.2877 9.47852 14.9288V13.3845C9.47852 13.0256 9.67422 12.8625 10.0114 12.8625C10.3485 12.8625 10.5552 13.0257 10.5552 13.3845V14.9288C10.5552 15.2877 10.3485 15.4508 10.0114 15.4508Z"
                        fill="#766326"></path>
                      <path
                        d="M9.38064 7.96875C9.18494 7.96875 9.01086 8.05571 8.9239 8.24063L5.10676 16.0816C5.07415 16.1469 5.05237 16.223 5.05237 16.2882C5.05237 16.5601 5.29158 16.8646 5.66135 16.8646C5.86799 16.8646 6.07463 16.7558 6.15076 16.5927L9.97883 8.75171C10.0115 8.68652 10.0223 8.61035 10.0223 8.54512C10.0222 8.19712 9.68513 7.96875 9.38064 7.96875Z"
                        fill="#766326"></path>
                      <path
                        d="M5.01973 8.41467C4.09531 8.41467 3.38843 8.80618 3.38843 9.88279V11.4271C3.38843 12.5037 4.09531 12.8952 5.01973 12.8952C5.93325 12.8952 6.65103 12.5037 6.65103 11.4271V9.88279C6.65103 8.80618 5.93325 8.41467 5.01973 8.41467ZM5.56353 11.4271C5.56353 11.786 5.35693 11.9491 5.01973 11.9491C4.68262 11.9491 4.48682 11.786 4.48682 11.4271V9.88279C4.48682 9.5239 4.68262 9.36082 5.01973 9.36082C5.35684 9.36082 5.56353 9.52395 5.56353 9.88279V11.4271Z"
                        fill="#766326"></path>
                    </svg> My Vouchers </a>
                  <a class="dropdown-item pf-item" (click)="goToPlanPage()"><svg width="25px" height="25px"
                      fill="#76632A" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="mr-3">
                      <path
                        d="M20 5h-4.762a4.457 4.457 0 0 1 .712 2H20a1 1 0 0 1 1 1v1h-6.354a3.491 3.491 0 0 0-5.621-3.975A5.6 5.6 0 0 0 8 6.715a5.6 5.6 0 0 0-1.025-1.69 3.5 3.5 0 0 0-4.95 4.95 5.529 5.529 0 0 0 3.248 1.007 16.578 16.578 0 0 0-2.664 3.564l1.781.908A15.036 15.036 0 0 1 8 11.2a15.036 15.036 0 0 1 3.609 4.256l1.781-.908A16.552 16.552 0 0 0 10.743 11H21v6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-3.471a12.61 12.61 0 0 0-1.719 2.38L5 16.46V17a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3zM3.438 8.559a1.5 1.5 0 0 1 2.123-2.12 7.916 7.916 0 0 1 1.144 2.592 7.849 7.849 0 0 1-3.267-.472zm9.125 0A5.577 5.577 0 0 1 10.218 9h-.913a7.948 7.948 0 0 1 1.134-2.561 1.5 1.5 0 0 1 2.124 2.12z">
                      </path>
                    </svg> My Plan </a>
                  <a class="dropdown-item pf-item" (click)="goToPackagePage()"> <img class="mr-3"
                      style="height: 25px; width: 25px;" src="../../../../assets/images/setting/package.png" alt=""> My
                    Packages </a>
                  <a class="dropdown-item pf-item" (click)="goToProductsPage()"> <svg class="mr-3"
                      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                      id="Layer_1" x="0px" y="0px" viewBox="0 0 122.88 114.5"
                      style="enable-background:new 0 0 122.88 114.5" xml:space="preserve" height="25" width="25"
                      fill="#766326">
                      <g>
                        <path
                          d="M118.66,9.63c0.67-0.13,1.37,0,1.95,0.35c0.99,0.41,1.69,1.38,1.69,2.52l0.57,79.58c0.05,0.98-0.43,1.95-1.33,2.48 l-32.5,19.39c-0.46,0.35-1.03,0.55-1.65,0.55c-0.15,0-0.3-0.01-0.44-0.04l-84.34-9.38C1.16,105.02,0,103.82,0,102.35V21.42h0 c-0.03-1.08,0.58-2.13,1.64-2.59l42.31-18.6l0,0c0.44-0.2,0.94-0.28,1.46-0.21L118.66,9.63L118.66,9.63z M90.14,33.86v73.06 l27.26-16.26l-0.53-73.65L90.14,33.86L90.14,33.86z M84.65,108.69V34.63l-35.97-4.59L47.5,64.41l-12.63-8.6l-12.63,7.14L24.85,27 L5.49,24.53v75.37L84.65,108.69L84.65,108.69z M78.96,9.94L52.43,25l34.51,4.4l24.19-15.24L78.96,9.94L78.96,9.94z M28.23,21.91 L53.95,6.66l-8.48-1.11L12.74,19.94L28.23,21.91L28.23,21.91z" />
                      </g>
                    </svg> My Products </a>
                  <a class="dropdown-item pf-item" (click)="goToStaffPage()"> <svg class="mr-3"
                      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                      id="Layer_1" x="0px" y="0px" viewBox="0 0 122.88 120.26"
                      style="enable-background:new 0 0 122.88 120.26" xml:space="preserve" height="25" width="25"
                      fill="#766326">
                      <g>
                        <path
                          d="M86.65,89.06v31.2h-4.72V87.13l-6.01-2.46L63.21,98.51h-3.54L46.96,84.67l-6.01,2.46v33.12h-4.72V89.06l-8.96,3.66v27.52 h-4.72V94.64l-6.52,2.66c-3.51,1.94-6.22,4.28-8.1,7.03c-1.86,2.72-2.94,5.88-3.21,9.5v6.4H0v-6.43h0c0-0.05,0-0.1,0.01-0.15 c0.32-4.45,1.65-8.38,4-11.81c2.31-3.37,5.56-6.2,9.74-8.5c0.1-0.06,0.21-0.11,0.32-0.16l30.88-12.61v-9.04 c-0.31-0.27-0.61-0.55-0.9-0.84c-4.31-4.24-7.21-10.57-8.04-20.11l-1.56-1.58c-0.47-0.41-0.77-1.01-0.77-1.67v-3.7h4.72v2.8 l1.6,1.62c0.39,0.4,0.61,0.9,0.64,1.41l0,0c0.64,8.81,3.1,14.46,6.77,18.08c3.55,3.49,8.38,5.18,13.87,6.03 c5.89-0.94,10.52-3.46,13.85-7.33c3.55-4.12,5.69-9.82,6.36-16.8c0.04-0.45,0.22-0.85,0.49-1.18l-0.01,0l1.44-1.77l0.03-3.03 l4.7,0.04l-0.03,3.63c0.04,0.54-0.12,1.09-0.49,1.55l-1.51,1.86c-0.83,7.59-3.3,13.88-7.34,18.58c-0.6,0.7-1.23,1.36-1.9,1.98v9.06 l31.94,13.05c0.11,0.05,0.22,0.1,0.32,0.16c4.18,2.3,7.43,5.13,9.74,8.5c2.34,3.42,3.68,7.35,4,11.81c0,0.05,0.01,0.1,0.01,0.15h0 v6.44h-4.72v-6.42c-0.28-3.62-1.35-6.79-3.21-9.5c-1.88-2.75-4.58-5.09-8.1-7.03l-6.52-2.66v25.6h-4.72V92.71L86.65,89.06 L86.65,89.06z M51.25,6.65c-0.27,0.01-0.53-0.04-0.77-0.12c-6.87,3.07-12.43,9.82-13.94,21.06c-0.16,1.24-1.34,2.11-2.63,1.96 c-1.29-0.16-2.2-1.29-2.04-2.52c1.76-13.1,8.48-21.02,16.79-24.66c4.19-1.84,8.76-2.57,13.28-2.31c4.51,0.25,8.98,1.48,13,3.56 c8.51,4.41,14.99,12.65,15.46,23.62c0.05,1.25-0.96,2.3-2.26,2.35c-1.3,0.05-2.39-0.92-2.44-2.17c-0.39-9.19-5.84-16.1-12.99-19.81 c-0.31-0.16-0.61-0.31-0.93-0.46c-0.26,0.09-0.54,0.14-0.84,0.13c-2.14-0.05-2.7,3.76-2.83,8.9c-0.06,2.3-0.01,4.84,0.04,7.43 c0.04,2.06,0.08,4.16,0.08,5.56c0,1.27-1.05,2.3-2.34,2.3c-1.29,0-2.34-1.03-2.34-2.3c0-2.28-0.03-3.9-0.06-5.49 c-0.05-2.65-0.1-5.23-0.04-7.61c0.12-4.64,0.67-8.56,2.37-10.93c-1.37-0.29-2.76-0.48-4.15-0.56c-1.75-0.1-3.5-0.02-5.22,0.23 c1.56,2.42,2.09,6.29,2.21,10.84c0.06,2.46,0.01,5.14-0.04,7.89c-0.03,1.64-0.06,3.31-0.06,5.63c0,1.26-1.02,2.28-2.28,2.28 c-1.26,0-2.28-1.02-2.28-2.28c0-1.45,0.04-3.59,0.08-5.7c0.05-2.7,0.1-5.33,0.04-7.71C54,10.49,53.43,6.59,51.25,6.65L51.25,6.65z M49.67,74.74v6.02l11.77,12.82l10.71-11.67v-7.34c-3.03,1.74-6.51,2.92-10.44,3.51c-0.25,0.04-0.51,0.05-0.78,0.01 C56.85,77.5,53.04,76.49,49.67,74.74L49.67,74.74z M32.08,30.03c0.61,1.29,1.8,2.45,3.42,3.46c5.23,3.27,14.43,4.84,23.93,4.87 c9.58,0.03,19.34-1.53,25.6-4.5c2.47-1.17,4.32-2.53,5.27-4.05l4.04,2.32c-1.44,2.31-3.97,4.24-7.23,5.78 c-6.9,3.28-17.44,4.99-27.69,4.96c-10.33-0.03-20.48-1.84-26.49-5.6c-2.35-1.47-4.13-3.26-5.13-5.37L32.08,30.03L32.08,30.03z M58.13,103.1h5.71v5.5h-5.71V103.1L58.13,103.1z M58.13,114.39h5.71v5.5h-5.71V114.39L58.13,114.39z" />
                      </g>
                    </svg> My Staff </a>
                  <a class="dropdown-item pf-item" (click)="goToClientPage()"> <img class="mr-3"
                      style="height: 20px; width: 25px;" src="../../../../assets/images/setting/client.png"> My Client
                  </a>
                </div>
                <!-- for add view -->
                <div class=" menu-items-pf pt-4">
                  <div class="Profile-datawrapper">
                    <h5 class="NameWrapper dirtyGreen tofino-b px-4">Add View</h5>
                  </div>
                  <a class="dropdown-item pf-item" (click)="goToAddServiesPage()"> <img class="mr-3"
                      style="height: 20px; width: 25px;" src="../../../../assets/images/setting/service.png"> Add
                      Service </a>
                  <a class="dropdown-item pf-item" (click)="goToVoucherAdd()"><svg width="25" height="25"
                      viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-3">
                      <path
                        d="M23.4855 4.32837H23.4399C22.8735 4.32837 2.37896 4.32837 1.56006 4.32837C0.699854 4.32837 0 5.02822 0 5.88843V19.1115C0 19.9717 0.699854 20.6716 1.56006 20.6716C2.39917 20.6716 22.8947 20.6716 23.4399 20.6716H23.4855C24.3206 20.6716 25 19.9921 25 19.1571V19.1115V5.88843V5.84287C25 5.00781 24.3206 4.32837 23.4855 4.32837ZM14.8481 9.01846L15.4118 9.58213L14.8481 10.1458C14.3487 10.6453 14.3487 11.4579 14.8481 11.9575L15.4118 12.5211L14.8481 13.0848C14.3487 13.5842 14.3487 14.3969 14.8481 14.8964L15.4118 15.4601L14.8481 16.0239C14.3487 16.5233 14.3487 17.336 14.8481 17.8355L15.4118 18.3992C14.7945 19.0164 14.8247 18.9836 14.7706 19.0482H1.62339V5.95176H14.7369C14.8082 6.04492 14.7962 6.02754 15.4119 6.64316L14.8481 7.20688C14.3487 7.70635 14.3487 8.51909 14.8481 9.01846ZM23.3766 19.0483H17.0006C17.2889 18.5575 17.2226 17.9143 16.8019 17.4934L16.2382 16.9297L16.8019 16.3661C17.3013 15.8667 17.3013 15.054 16.8019 14.5544L16.2382 13.9908L16.8019 13.4271C17.3013 12.9277 17.3013 12.115 16.8019 11.6155L16.2382 11.0518L16.8019 10.4881C17.0438 10.2462 17.1771 9.92451 17.1771 9.58228C17.1771 9.24014 17.0438 8.91841 16.8019 8.67647L16.2382 8.11279L16.8019 7.54907C17.2349 7.11602 17.2924 6.44756 16.9746 5.9519H23.3766V19.0483V19.0483Z"
                        fill="#766326"></path>
                      <path
                        d="M10.0114 11.9164C9.08701 11.9164 8.38013 12.3079 8.38013 13.3845V14.9288C8.38013 16.0054 9.08701 16.3969 10.0114 16.3969C10.925 16.3969 11.6427 16.0054 11.6427 14.9288V13.3845C11.6427 12.3079 10.925 11.9164 10.0114 11.9164ZM10.0114 15.4508C9.67432 15.4508 9.47852 15.2877 9.47852 14.9288V13.3845C9.47852 13.0256 9.67422 12.8625 10.0114 12.8625C10.3485 12.8625 10.5552 13.0257 10.5552 13.3845V14.9288C10.5552 15.2877 10.3485 15.4508 10.0114 15.4508Z"
                        fill="#766326"></path>
                      <path
                        d="M9.38064 7.96875C9.18494 7.96875 9.01086 8.05571 8.9239 8.24063L5.10676 16.0816C5.07415 16.1469 5.05237 16.223 5.05237 16.2882C5.05237 16.5601 5.29158 16.8646 5.66135 16.8646C5.86799 16.8646 6.07463 16.7558 6.15076 16.5927L9.97883 8.75171C10.0115 8.68652 10.0223 8.61035 10.0223 8.54512C10.0222 8.19712 9.68513 7.96875 9.38064 7.96875Z"
                        fill="#766326"></path>
                      <path
                        d="M5.01973 8.41467C4.09531 8.41467 3.38843 8.80618 3.38843 9.88279V11.4271C3.38843 12.5037 4.09531 12.8952 5.01973 12.8952C5.93325 12.8952 6.65103 12.5037 6.65103 11.4271V9.88279C6.65103 8.80618 5.93325 8.41467 5.01973 8.41467ZM5.56353 11.4271C5.56353 11.786 5.35693 11.9491 5.01973 11.9491C4.68262 11.9491 4.48682 11.786 4.48682 11.4271V9.88279C4.48682 9.5239 4.68262 9.36082 5.01973 9.36082C5.35684 9.36082 5.56353 9.52395 5.56353 9.88279V11.4271Z"
                        fill="#766326"></path>
                    </svg> Add Vouchers </a>
                  <a class="dropdown-item pf-item" (click)="goToAddPlanPage()"><svg width="25px" height="25px"
                      fill="#76632A" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="mr-3">
                      <path
                        d="M20 5h-4.762a4.457 4.457 0 0 1 .712 2H20a1 1 0 0 1 1 1v1h-6.354a3.491 3.491 0 0 0-5.621-3.975A5.6 5.6 0 0 0 8 6.715a5.6 5.6 0 0 0-1.025-1.69 3.5 3.5 0 0 0-4.95 4.95 5.529 5.529 0 0 0 3.248 1.007 16.578 16.578 0 0 0-2.664 3.564l1.781.908A15.036 15.036 0 0 1 8 11.2a15.036 15.036 0 0 1 3.609 4.256l1.781-.908A16.552 16.552 0 0 0 10.743 11H21v6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-3.471a12.61 12.61 0 0 0-1.719 2.38L5 16.46V17a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3zM3.438 8.559a1.5 1.5 0 0 1 2.123-2.12 7.916 7.916 0 0 1 1.144 2.592 7.849 7.849 0 0 1-3.267-.472zm9.125 0A5.577 5.577 0 0 1 10.218 9h-.913a7.948 7.948 0 0 1 1.134-2.561 1.5 1.5 0 0 1 2.124 2.12z">
                      </path>
                    </svg> Add Plan </a>
                  <a class="dropdown-item pf-item" (click)=" goToAddPackagePage()"> <img class="mr-3"
                      style="height: 25px; width: 25px;" src="../../../../assets/images/setting/package.png" alt=""> Add
                    Packages </a>
                  <a class="dropdown-item pf-item" (click)="goToAddProductsPage()"> <svg class="mr-3"
                      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                      id="Layer_1" x="0px" y="0px" viewBox="0 0 122.88 114.5"
                      style="enable-background:new 0 0 122.88 114.5" xml:space="preserve" height="25" width="25"
                      fill="#766326">
                      <g>
                        <path
                          d="M118.66,9.63c0.67-0.13,1.37,0,1.95,0.35c0.99,0.41,1.69,1.38,1.69,2.52l0.57,79.58c0.05,0.98-0.43,1.95-1.33,2.48 l-32.5,19.39c-0.46,0.35-1.03,0.55-1.65,0.55c-0.15,0-0.3-0.01-0.44-0.04l-84.34-9.38C1.16,105.02,0,103.82,0,102.35V21.42h0 c-0.03-1.08,0.58-2.13,1.64-2.59l42.31-18.6l0,0c0.44-0.2,0.94-0.28,1.46-0.21L118.66,9.63L118.66,9.63z M90.14,33.86v73.06 l27.26-16.26l-0.53-73.65L90.14,33.86L90.14,33.86z M84.65,108.69V34.63l-35.97-4.59L47.5,64.41l-12.63-8.6l-12.63,7.14L24.85,27 L5.49,24.53v75.37L84.65,108.69L84.65,108.69z M78.96,9.94L52.43,25l34.51,4.4l24.19-15.24L78.96,9.94L78.96,9.94z M28.23,21.91 L53.95,6.66l-8.48-1.11L12.74,19.94L28.23,21.91L28.23,21.91z" />
                      </g>
                    </svg> Add Products </a>
                  <a class="dropdown-item pf-item" (click)="goToAddStaffPage()"> <svg class="mr-3"
                      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                      id="Layer_1" x="0px" y="0px" viewBox="0 0 122.88 120.26"
                      style="enable-background:new 0 0 122.88 120.26" xml:space="preserve" height="25" width="25"
                      fill="#766326">
                      <g>
                        <path
                          d="M86.65,89.06v31.2h-4.72V87.13l-6.01-2.46L63.21,98.51h-3.54L46.96,84.67l-6.01,2.46v33.12h-4.72V89.06l-8.96,3.66v27.52 h-4.72V94.64l-6.52,2.66c-3.51,1.94-6.22,4.28-8.1,7.03c-1.86,2.72-2.94,5.88-3.21,9.5v6.4H0v-6.43h0c0-0.05,0-0.1,0.01-0.15 c0.32-4.45,1.65-8.38,4-11.81c2.31-3.37,5.56-6.2,9.74-8.5c0.1-0.06,0.21-0.11,0.32-0.16l30.88-12.61v-9.04 c-0.31-0.27-0.61-0.55-0.9-0.84c-4.31-4.24-7.21-10.57-8.04-20.11l-1.56-1.58c-0.47-0.41-0.77-1.01-0.77-1.67v-3.7h4.72v2.8 l1.6,1.62c0.39,0.4,0.61,0.9,0.64,1.41l0,0c0.64,8.81,3.1,14.46,6.77,18.08c3.55,3.49,8.38,5.18,13.87,6.03 c5.89-0.94,10.52-3.46,13.85-7.33c3.55-4.12,5.69-9.82,6.36-16.8c0.04-0.45,0.22-0.85,0.49-1.18l-0.01,0l1.44-1.77l0.03-3.03 l4.7,0.04l-0.03,3.63c0.04,0.54-0.12,1.09-0.49,1.55l-1.51,1.86c-0.83,7.59-3.3,13.88-7.34,18.58c-0.6,0.7-1.23,1.36-1.9,1.98v9.06 l31.94,13.05c0.11,0.05,0.22,0.1,0.32,0.16c4.18,2.3,7.43,5.13,9.74,8.5c2.34,3.42,3.68,7.35,4,11.81c0,0.05,0.01,0.1,0.01,0.15h0 v6.44h-4.72v-6.42c-0.28-3.62-1.35-6.79-3.21-9.5c-1.88-2.75-4.58-5.09-8.1-7.03l-6.52-2.66v25.6h-4.72V92.71L86.65,89.06 L86.65,89.06z M51.25,6.65c-0.27,0.01-0.53-0.04-0.77-0.12c-6.87,3.07-12.43,9.82-13.94,21.06c-0.16,1.24-1.34,2.11-2.63,1.96 c-1.29-0.16-2.2-1.29-2.04-2.52c1.76-13.1,8.48-21.02,16.79-24.66c4.19-1.84,8.76-2.57,13.28-2.31c4.51,0.25,8.98,1.48,13,3.56 c8.51,4.41,14.99,12.65,15.46,23.62c0.05,1.25-0.96,2.3-2.26,2.35c-1.3,0.05-2.39-0.92-2.44-2.17c-0.39-9.19-5.84-16.1-12.99-19.81 c-0.31-0.16-0.61-0.31-0.93-0.46c-0.26,0.09-0.54,0.14-0.84,0.13c-2.14-0.05-2.7,3.76-2.83,8.9c-0.06,2.3-0.01,4.84,0.04,7.43 c0.04,2.06,0.08,4.16,0.08,5.56c0,1.27-1.05,2.3-2.34,2.3c-1.29,0-2.34-1.03-2.34-2.3c0-2.28-0.03-3.9-0.06-5.49 c-0.05-2.65-0.1-5.23-0.04-7.61c0.12-4.64,0.67-8.56,2.37-10.93c-1.37-0.29-2.76-0.48-4.15-0.56c-1.75-0.1-3.5-0.02-5.22,0.23 c1.56,2.42,2.09,6.29,2.21,10.84c0.06,2.46,0.01,5.14-0.04,7.89c-0.03,1.64-0.06,3.31-0.06,5.63c0,1.26-1.02,2.28-2.28,2.28 c-1.26,0-2.28-1.02-2.28-2.28c0-1.45,0.04-3.59,0.08-5.7c0.05-2.7,0.1-5.33,0.04-7.71C54,10.49,53.43,6.59,51.25,6.65L51.25,6.65z M49.67,74.74v6.02l11.77,12.82l10.71-11.67v-7.34c-3.03,1.74-6.51,2.92-10.44,3.51c-0.25,0.04-0.51,0.05-0.78,0.01 C56.85,77.5,53.04,76.49,49.67,74.74L49.67,74.74z M32.08,30.03c0.61,1.29,1.8,2.45,3.42,3.46c5.23,3.27,14.43,4.84,23.93,4.87 c9.58,0.03,19.34-1.53,25.6-4.5c2.47-1.17,4.32-2.53,5.27-4.05l4.04,2.32c-1.44,2.31-3.97,4.24-7.23,5.78 c-6.9,3.28-17.44,4.99-27.69,4.96c-10.33-0.03-20.48-1.84-26.49-5.6c-2.35-1.47-4.13-3.26-5.13-5.37L32.08,30.03L32.08,30.03z M58.13,103.1h5.71v5.5h-5.71V103.1L58.13,103.1z M58.13,114.39h5.71v5.5h-5.71V114.39L58.13,114.39z" />
                      </g>
                    </svg> Add Staff </a>
                  <a class="dropdown-item pf-item" (click)="goToAddClientPage()"> <img class="mr-3"
                      style="height: 20px; width: 25px;" src="../../../../assets/images/setting/client.png"> Add Client
                  </a>
                </div>
              </div>
            </div>
          </div>
        </li>


        <!-- ispublish Button -->
        <li class="publish-txt" *ngIf="!router.url.includes('/admin')">
          Ready For Market
          <mat-slide-toggle [checked]="isPublishData" (click)="callisPublish()">

          </mat-slide-toggle>
        </li>
        <!-- Full Screen Button -->
        <li class="fullscreen">
          <button mat-icon-button (click)="callFullscreen()" class="nav-notification-icons">
            <mat-icon class="f-screen" title="Full-Screen">fullscreen</mat-icon>
          </button>
        </li>
        <!-- #END# Full Screen Button -->
        <!-- #START# Notifications-->
        <li class="dropdown">
          <button title="Notifications" mat-icon-button class="nav-notification-icons" (click)="callNotification()">

            <svg width="25" height="25" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_3005_1232)">
                <path
                  d="M18.02 1.82373C19.7842 2.36971 21.3738 3.36994 22.6294 4.72412C23.9881 6.17374 24.9002 7.9843 25.2563 9.93897V10.0073C25.3076 10.3027 25.3442 10.5835 25.3662 10.8472C25.3931 11.1548 25.4077 11.4648 25.4077 11.7749V14.248C25.4077 14.9341 25.4077 15.6323 25.4565 16.333C25.5208 17.5901 25.884 18.8138 26.5161 19.9023C27.2273 21.0172 28.1771 21.9603 29.2969 22.6636C29.6145 22.8713 29.8447 23.1884 29.9438 23.5547C30.0181 23.8406 30.0113 24.1415 29.9243 24.4238C29.8386 24.7059 29.6773 24.9592 29.458 25.1563C29.1713 25.4077 28.8017 25.5442 28.4204 25.5396H20.0854V25.5591C19.0747 31.4673 10.9033 31.4502 9.91699 25.5396H1.57471C1.17267 25.5486 0.782948 25.4006 0.48828 25.127C0.278673 24.9267 0.126989 24.6735 0.0492167 24.3942C-0.0285553 24.1149 -0.0295335 23.8198 0.0463851 23.54C0.151748 23.162 0.39702 22.8381 0.73242 22.6343C2.11426 21.6992 3.08105 20.6812 3.6914 19.519C4.30176 18.3569 4.58252 16.9702 4.58252 15.3003V11.7749C4.58252 11.4917 4.59717 11.1841 4.62646 10.8545C4.65576 10.5249 4.69726 10.2393 4.75097 9.93653C5.10241 8.0403 5.97068 6.27796 7.26006 4.84384C8.54943 3.40972 10.2098 2.35953 12.0581 1.80908C13.1836 -0.603026 16.8945 -0.607908 18.02 1.82373ZM21.4136 5.85938C20.2726 4.62729 18.8055 3.74429 17.1826 3.31299C17.0447 3.27511 16.9189 3.20246 16.8172 3.102C16.7154 3.00154 16.6412 2.87664 16.6016 2.73926C16.1841 1.30615 13.916 1.27442 13.4961 2.72705C13.4552 2.86861 13.3777 2.99687 13.2714 3.0989C13.1651 3.20092 13.0337 3.27308 12.8906 3.30811C11.2584 3.71995 9.77817 4.59064 8.62516 5.81721C7.47214 7.04378 6.69452 8.57491 6.38428 10.2295C6.3387 10.4867 6.30452 10.743 6.28174 10.9985C6.25976 11.2427 6.25 11.4868 6.25 11.7749V15.3003C6.25 17.2314 5.91308 18.855 5.16357 20.2881C4.4458 21.6602 3.3667 22.8247 1.85791 23.8818H28.1421C26.9162 23.067 25.8783 21.9999 25.0977 20.752C24.3317 19.4425 23.8882 17.9697 23.8037 16.4551C23.75 15.752 23.7524 14.9902 23.7549 14.2578V11.7749C23.7549 11.5063 23.7549 11.2451 23.7231 10.9888C23.6914 10.7324 23.6719 10.5005 23.6353 10.293L23.6206 10.2271C23.3214 8.59012 22.5588 7.07341 21.4233 5.85694L21.4136 5.85938Z"
                  fill="#766326" />
              </g>
              <defs>
                <clipPath id="clip0_3005_1232">
                  <rect width="30" height="29.9878" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span class="pr-count-n label-count bg-danger text-white">{{notificationCount}}</span>
          </button>
          <button mat-icon-button data-toggle="dropdown" class="nav-notification-icons d-none"
            (click)="callNotificationPartner()">
            <mat-icon>notifications_important</mat-icon>
            <span class="label-count bg-orange">{{notificationCount}}</span>
          </button>
          <ul class="dropdown-menu noti-fs pullDown p-3">
            <li class="header d-flex align-items-center justify-content-between">
              <span class="notific-txt">NOTIFICATIONS </span>
              <span><button mat-raised-button type="button" color="primary" (click)="MarkAsReadAll()">Read All</button></span>
              <span (click)="close()" class="noti-fs-close"><svg xmlns="http://www.w3.org/2000/svg" width="21"
                  height="21" viewBox="0 0 21 21" fill="none">
                  <g clip-path="url(#clip0_2946_2825)">
                    <path
                      d="M21 2.115L18.885 0L10.5 8.385L2.115 0L0 2.115L8.385 10.5L0 18.885L2.115 21L10.5 12.615L18.885 21L21 18.885L12.615 10.5L21 2.115Z"
                      fill="#766326" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2946_2825">
                      <rect width="21" height="21" fill="white" />
                    </clipPath>
                  </defs>
                </svg></span>
            </li>
            <li class="body d-none">
              <ul class="menu" style="position: relative; max-width: 600px; max-height: 200px" [perfectScrollbar]>
                <li>
                  <a *ngFor="let notification of notifications" (click)="redirect(notification)">
                    <span class="menu-info">
                      <span class="menu-desc" [ngClass]="[notification.isRead? 'read':'unread']">{{ notification.remarks
                        }}</span>
                    </span>
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <div class="notifications-wrapper">
                <mat-tab-group class="noti-tabs mb-0">
                  <mat-tab *ngFor="let notification of notificationtype">
                    <ng-template mat-tab-label>
                      <div class="tab-heading mt-2">
                        <span class="img-circul">
                          <!-- <img src="https://i.ibb.co/c2zgqPW/star-svgrepo-com-1-1.png"> -->
                          <i class="fas fa-calendar-check"></i>
                        </span>

                        <p class="mb-0">{{notification.displayname}}</p>
                      </div>
                    </ng-template>
                    <div class="tab-content-nt" *ngIf="notification.displayname == 'Appointment'">
                      <h6 class="noti-hd-txt py-3">Appointment</h6>
                      <div class="noti-rows d-flex align-items-center mb-2"
                        *ngFor="let appointment of appointmentNotification" (click)="gotoappointment(appointment)">
                        <span><img class="rounded-circle" height="50px" width="50px" [src]="appointment.clientImage"
                            alt=""> </span>
                        <div class="side-content ml-3">
                          <div class="top-txt align-items-center d-flex justify-content-between py-2">
                            <h6 class="hd-txt mb-0" (click)="gotoappointment(appointment)">{{appointment.title}}</h6> <span
                              class="sub-txt" (click)="gotoappointment(appointment)">{{appointment.createdAt | date:'d MMM y'}}</span>
                          </div>
                          <p class="sub-txt full-txt mb-0 py-2" (click)="gotoappointment(appointment)">{{appointment.text}}</p>
                        </div>
                      </div>
                      <p *ngIf="appointmentNotification.length == 0 || appointmentNotification == undefined">No
                        Appointment Notification.</p>
                    </div>

                    <div class="tab-content-nt" *ngIf="notification.displayname == 'Sold Voucher'">
                      <h6 class="noti-hd-txt py-3">Voucher</h6>
                      <div class="noti-rows d-flex align-items-center mb-2" *ngFor="let voucher of voucherNotification"
                        (click)="gotovoucherSales(voucher)">
                        <span><img class="rounded-circle" height="50px" width="50px" [src]="voucher.clientImage" alt="">
                        </span>
                        <div class="side-content ml-3">
                          <div class="top-txt align-items-center d-flex justify-content-between py-2">
                            <h6 class="hd-txt mb-0">{{voucher.title}}</h6> <span class="sub-txt">{{voucher.createdAt |
                              date:'d MMM y'}}</span>
                          </div>
                          <p class="sub-txt full-txt mb-0 py-2">{{voucher.text}}</p>
                        </div>
                      </div>
                      <p *ngIf="voucherNotification.length == 0 || voucherNotification == undefined">No Voucher
                        Notification.</p>
                    </div>

                    <div class="tab-content-nt" *ngIf="notification.displayname == 'Sold Plan'">
                      <h6 class="noti-hd-txt py-3">Plan</h6>
                      <div class="noti-rows d-flex align-items-center mb-2" *ngFor="let member of memberNotification"
                        (click)="gotomembershipSales(member)">
                        <span><img class="rounded-circle" height="50px" width="50px" [src]="member.clientImage" alt="">
                        </span>
                        <div class="side-content ml-3">
                          <div class="top-txt align-items-center d-flex justify-content-between py-2">
                            <h6 class="hd-txt mb-0">{{member.title}}</h6> <span class="sub-txt">{{member.createdAt |
                              date:'d MMM y'}}</span>
                          </div>
                          <p class="sub-txt full-txt mb-0 py-2">{{member.text}}</p>
                        </div>
                      </div>
                      <p *ngIf="memberNotification.length == 0 || memberNotification == undefined">No Member
                        Notification.</p>
                    </div>

                    <div class="tab-content-nt" *ngIf="notification.displayname == 'Sold Product'">
                      <h6 class="noti-hd-txt py-3">Product</h6>
                      <div class="noti-rows d-flex align-items-center mb-2" *ngFor="let product of productNotification"
                        (click)="gotoproductSales(product)">
                        <span><img class="rounded-circle" height="50px" width="50px" [src]="product.clientImage" alt="">
                        </span>
                        <div class="side-content ml-3">
                          <div class="top-txt align-items-center d-flex justify-content-between py-2">
                            <h6 class="hd-txt mb-0 ">{{product.title}}</h6> <span class="sub-txt">{{product.createdAt |
                              date:'d MMM y'}}</span>
                          </div>
                          <p class="sub-txt full-txt mb-0 py-2">{{product.text}}</p>
                        </div>
                      </div>
                      <p *ngIf="productNotification.length == 0 || productNotification == undefined">No Product
                        Notification.</p>
                    </div>

                    <div class="tab-content-nt" *ngIf="notification.displayname == 'Review'">
                      <h6 class="noti-hd-txt py-3">Review</h6>
                      <div class="noti-rows d-flex align-items-center mb-2" *ngFor="let review of reviewNotification"
                        (click)="gotoReviewSales(review)">
                        <span><img class="rounded-circle" height="50px" width="50px" [src]="review.clientImage" alt="">
                        </span>
                        <div class="side-content ml-3">
                          <div class="top-txt align-items-center d-flex justify-content-between py-2">
                            <h6 class="hd-txt mb-0">{{review.title}}</h6> <span class="sub-txt">{{review.createdAt |
                              date:'d MMM y'}}</span>
                          </div>
                          <p class="sub-txt full-txt mb-0 py-2">{{review.text}}</p>
                        </div>
                      </div>
                      <p *ngIf="reviewNotification.length == 0 || reviewNotification == undefined">No Review
                        Notification.</p>
                    </div>

                    <div class="tab-content-nt" *ngIf="notification.displayname == 'Stock'">
                      <h6 class="noti-hd-txt py-3">Stock</h6>
                      <div class="noti-rows d-flex align-items-center mb-2" *ngFor="let stock of stockNotification"
                        (click)="gotoStock(stock)">
                        <span><img class="rounded-circle" height="50px" width="50px" [src]="stock.clientImage" alt="">
                        </span>
                        <div class="side-content ml-3">
                          <div class="top-txt align-items-center d-flex justify-content-between py-2">
                            <h6 class="hd-txt mb-0">{{stock.title}}</h6> <span class="sub-txt">{{stock.createdAt |
                              date:'d MMM y'}}</span>
                          </div>
                          <p class="sub-txt full-txt mb-0 py-2">{{stock.text}}</p>
                        </div>
                      </div>
                      <p *ngIf="stockNotification.length == 0 || stockNotification == undefined">No Stock Notification.
                      </p>
                    </div>
                  </mat-tab>
                  <!-- <mat-tab>
                        <ng-template mat-tab-label>
                          <div class="tab-heading mt-2">
                            <span class="img-circul">
                              <i class="far fa-star"></i>
                            </span>
                           
                            <p class="mb-0">Reviews</p>
                          </div>                      
                      </ng-template>
                      <div class="tab-content-nt">
                        <h6 class="noti-hd-txt py-3">Reviews</h6>
                        <div class="noti-rows d-flex align-items-center mb-2">
                          <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                          <div class="side-content ml-3">
                            <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                            <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                          </div>
                        </div>
  
                        <div class="noti-rows d-flex align-items-center mb-2">
                          <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                          <div class="side-content ml-3">
                            <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                            <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                          </div>
                        </div>
  
                        <div class="noti-rows d-flex align-items-center mb-2">
                          <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                          <div class="side-content ml-3">
                            <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                            <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                          </div>
                        </div>
                        <div class="noti-rows d-flex align-items-center mb-2">
                          <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                          <div class="side-content ml-3">
                            <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                            <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                          </div>
                        </div>
                      </div>
                     
  
                        </mat-tab>

                        <mat-tab>
                          <ng-template mat-tab-label>
                            <div class="tab-heading mt-2">
                              <span class="img-circul">
                               
                                <i class="fas fa-coins"></i>
                              </span>
                             
                              <p class="mb-0">Tips</p>
                            </div>                      
                        </ng-template>
                        <div class="tab-content-nt">
                          <h6 class="noti-hd-txt py-3">Tips</h6>
                          <div class="noti-rows d-flex align-items-center mb-2">
                            <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                            <div class="side-content ml-3">
                              <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                              <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                            </div>
                          </div>
    
                          <div class="noti-rows d-flex align-items-center mb-2">
                            <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                            <div class="side-content ml-3">
                              <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                              <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                            </div>
                          </div>
    
                          <div class="noti-rows d-flex align-items-center mb-2">
                            <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                            <div class="side-content ml-3">
                              <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                              <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                            </div>
                          </div>
                          <div class="noti-rows d-flex align-items-center mb-2">
                            <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                            <div class="side-content ml-3">
                              <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                              <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                            </div>
                          </div>
                        </div>
                       
    
                          </mat-tab>

                          <mat-tab>
                            <ng-template mat-tab-label>
                              <div class="tab-heading mt-2">
                                <span class="img-circul">
                                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" id="Layer_1" width="30px" height="30px" viewBox="0 0 64 64" enable-background="new 0 0 64 64" xml:space="preserve">
                                    <g>
                                      <polygon fill="none" stroke="#76632a" stroke-width="4" stroke-miterlimit="10" points="21.903,5 55,38.097 34.097,59 1,25.903    1,5  "/>
                                      <polyline fill="none" stroke="#76632a" stroke-width="4" stroke-miterlimit="10" points="29.903,5 63,38.097 42.097,59  "/>
                                      <circle fill="none" stroke="#76632a" stroke-width="4" stroke-miterlimit="10" cx="14" cy="18" r="5"/>
                                    </g>
                                    </svg>
                                </span>
                               
                                <p class="mb-0">Sales</p>
                              </div>                      
                          </ng-template>
                          <div class="tab-content-nt">
                            <h6 class="noti-hd-txt py-3">Sales</h6>
                            <div class="noti-rows d-flex align-items-center mb-2">
                              <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                              <div class="side-content ml-3">
                                <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                                <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                              </div>
                            </div>
      
                            <div class="noti-rows d-flex align-items-center mb-2">
                              <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                              <div class="side-content ml-3">
                                <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                                <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                              </div>
                            </div>
      
                            <div class="noti-rows d-flex align-items-center mb-2">
                              <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                              <div class="side-content ml-3">
                                <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                                <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                              </div>
                            </div>
                            <div class="noti-rows d-flex align-items-center mb-2">
                              <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                              <div class="side-content ml-3">
                                <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                                <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                              </div>
                            </div>
                          </div>
                         
      
                            </mat-tab>

                            <mat-tab>
                              <ng-template mat-tab-label>
                                <div class="tab-heading mt-2">
                                  <span class="img-circul">
                                    <i class="fas fa-boxes"></i>
                                  </span>
                                 
                                  <p class="mb-0">Inventory</p>
                                </div>                      
                            </ng-template>
                            <div class="tab-content-nt">
                              <h6 class="noti-hd-txt py-3">Sales</h6>
                              <div class="noti-rows d-flex align-items-center mb-2">
                                <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                                <div class="side-content ml-3">
                                  <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                                  <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                                </div>
                              </div>
        
                              <div class="noti-rows d-flex align-items-center mb-2">
                                <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                                <div class="side-content ml-3">
                                  <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                                  <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                                </div>
                              </div>
        
                              <div class="noti-rows d-flex align-items-center mb-2">
                                <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                                <div class="side-content ml-3">
                                  <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                                  <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                                </div>
                              </div>
                              <div class="noti-rows d-flex align-items-center mb-2">
                                <span><img class="rounded-circle" height="50px" src="https://i.ibb.co/yQ5PL4H/unnamed.png" alt=""> </span>
                                <div class="side-content ml-3">
                                  <div class="top-txt align-items-center d-flex justify-content-between py-2"> <h6 class="hd-txt mb-0">New appointment (DEMO)</h6> <span class="sub-txt"> 3 hours ago</span> </div>
                                  <p class="sub-txt full-txt mb-0 py-2">10am today Manicure for Jack booked with Wendy</p>
                                </div>
                              </div>
                            </div>
                           
        
                              </mat-tab> -->
                </mat-tab-group>
              </div>
            </li>
          </ul>
        </li>
        <!-- #end# Notifications-->

        <li class="dropdown user_profile mr-3">
          <a href="#" title="Porfile" onClick="javacript:void(0)" data-toggle="dropdown" role="button" class="pt-0"
            style="background-color: #fff;">
            <img src="{{ userImg || 'assets/images/user/user1.jpg' }}" class="rounded-circle" width="32" height="32"
              alt="User" />
            <!-- <label for="" *ngIf="loginUser" class="label label-primary ml-1">{{loginUser}}</label> -->
            <!-- <button mat-raised-button color ="primary" *ngIf="loginUser" >{{loginUser}}</button> -->
          </a>
          <ul class="dropdown-menu pf-drop-down pullDown mr-3" style="margin-bottom:17px;">
            <li class="body">
              <ul class="user_dw_menu">
                <li class="d-flex align-items-center pf-items-menu" *ngIf="loginUser" (click)="profileEdit()">
                  <a class="w-100">
                    <mat-icon aria-hidden="false" class="mr-2">person</mat-icon>
                    {{loginUser}}
                  </a>
                </li>
                <!-- <li>
                  <a href="#" onClick="javacript:void(0)">
                    <mat-icon aria-hidden="false" class="mr-2">feedback</mat-icon>
                    Feedback
                  </a>
                </li>
                <li>
                  <a href="#" onClick="javacript:void(0)">
                    <mat-icon aria-hidden="false" class="mr-2">help</mat-icon>
                    Help
                  </a>
                </li> -->

                <li class="d-flex align-items-center pf-items-menu" (click)="logout()">
                  <a class="w-100">
                    <mat-icon aria-hidden="false" class="mr-2">power_settings_new</mat-icon>
                    Logout
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>

        <!-- #END# Tasks -->
        <li class="pull-right">
          <!-- <button mat-icon-button (click)="toggleRightSidebar()" class="nav-notification-icons js-right-sidebar">
            <mat-icon id="settingBtn">settings</mat-icon>
          </button> -->
        </li>
      </ul>
      <div class="nav-menu d-lg-block pull-right" style="margin-top: 10px; margin-right: 20px"
        *ngIf="router.url.includes('/patient')">
        <ul>
          <li class="active"><a href="/watchfuleye.in/#/watchfuleye/home">Home</a></li>
          <li class="drop-down">
            <a href="">About us</a>
            <ul>
              <li><a href="/watchfuleye.in/#/watchfuleye/aboutus">About us</a></li>
              <li><a href="/watchfuleye.in/#/watchfuleye/team">Team</a></li>
            </ul>
          </li>
          <li class="drop-down">
            <a href="">Services</a>
            <ul>
              <li>
                <a href="/watchfuleye.in/#/watchfuleye/healthcare">Healthcare Services</a>
              </li>

              <li><a href="/watchfuleye.in/#/watchfuleye/emergency">Emergency Services</a></li>
              <li>
                <a href="/watchfuleye.in/#/watchfuleye/convenience">Convenience Services</a>
              </li>
              <li>
                <a href="/watchfuleye.in/#/watchfuleye/volunteer">Volunteers Services</a>
              </li>
            </ul>
          </li>
          <li><a href="/watchfuleye.in/#/watchfuleye/plan">Plan</a></li>
        </ul>
      </div>
    </div>
  </div>
</nav>